export interface FeatureState {}

export const initialState: FeatureState = {};
